module.exports = __webpack_public_path__ + "static/driver-guy-posing-to-the-camera-4783aed5a06f996546e8e1256357d733.jpg";